module.exports = __webpack_public_path__ + "img/MobileMarketing.39057811.svg";